import { useContext, useEffect } from 'react'

import AuthContext from '../../../../context/AuthContext'
import Title from '../../../../components/Title'
import CreditPackageItem from './Package'
import usePrivateApi from '../../../../hooks/usePrivateApi'

const WhiteLabelCreditPackages = () => {
  const [auth] = useContext(AuthContext)
  const { credit } = auth.membership.dealer

  const [{ res, success, error, isLoading }, { sendRequest, resetSuccess }] =
    usePrivateApi()

  useEffect(() => {
    if (success) {
      window.location = res.data.url
    }
  }, [res, success, resetSuccess])

  const redirectToCheckout = (creditPackageId) => {
    sendRequest({
      url: '/billing/subdealer/credits/checkout',
      method: 'post',
      data: { creditPackageId },
    })
  }

  const renderBalance = () => {
    if (credit.balance === 0) {
      return 'You have no credits in your account'
    }

    if (credit.balance === 1) {
      return 'You have 1 credit in your account'
    }

    return <>You have {credit.balance} credits in your account</>
  }

  return (
    <>
      <Title title="Credit packages" />
      <div className="max-w-5xl mx-auto px-4">
        <div className="bg-white rounded-lg border border-gray-200 flex flex-col shadow-xs">
          <div className="border-b border-gray-200 rounded-tr-lg rounded-tl-lg px-6 py-4">
            <h5 className="font-semibold tracking-tighter text-lg">
              {renderBalance()}
            </h5>
          </div>
          {credit.packages.length === 0 ? (
            <div className="py-4 px-6 text-sm text-gray-700">
              <p>
                You do not have any packages you can purchase. Please contact
                your master dealer.
              </p>
            </div>
          ) : (
            <div className="divide-y divide-gray-200">
              {credit.packages
                .sort((a, b) => (a.cost > b.cost ? 1 : -1))
                .map((creditPackage) => (
                  <CreditPackageItem
                    creditPackage={creditPackage}
                    key={creditPackage.id}
                    onClick={() => redirectToCheckout(creditPackage.id)}
                    disabled={isLoading}
                  />
                ))}
              {error && (
                <p className=" px-6 py-6 text-sm text-red-600">
                  Error: Refer to master
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default WhiteLabelCreditPackages
